import styled from 'styled-components';
import { translations } from '../data/i18n';
import { siteConfig } from '../data/site';

const Page = styled.main`
  padding: calc(var(--nav-height) + 70px) 28px 90px;
  background:
    radial-gradient(circle at top right, rgba(221,161,47,0.12), transparent 34%),
    var(--cream);
  min-height: calc(100vh - var(--nav-height));
`;

const Card = styled.div`
  max-width: 980px;
  margin: 0 auto;
  background: var(--cream-card);
  border-radius: 26px;
  padding: clamp(28px, 4vw, 52px);
  box-shadow: var(--shadow);
  border: 1px solid rgba(221,161,47,0.12);
`;

const Eyebrow = styled.div`
  color: var(--gold-dark);
  font-weight: 950;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 12px;
`;

const Title = styled.h1`
  margin: 0 0 26px;
  color: var(--black);
  font-size: clamp(2.4rem, 5vw, 4.3rem);
  line-height: 0.95;
  letter-spacing: -2px;
  text-transform: uppercase;
`;

const Section = styled.section`
  margin-top: 34px;

  h2 {
    margin: 0 0 14px;
    color: var(--black);
    font-size: 1.35rem;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    color: var(--muted);
    line-height: 1.75;
  }

  a {
    color: var(--gold-dark);
    font-weight: 900;
  }
`;

function Datenschutz({ language = 'de' }) {
  const t = translations[language]?.legal || translations.de.legal;
  const isEnglish = language === 'en';

  return (
    <Page>
      <Card>
        <Eyebrow>{siteConfig.brandName}</Eyebrow>
        <Title>{t.privacyTitle || 'Datenschutz'}</Title>

        <Section>
          <h2>{isEnglish ? 'General information' : 'Allgemeine Hinweise'}</h2>
          <p>
            {isEnglish
              ? 'The protection of personal data is important to us. This website only collects and processes data where it is necessary for contact, appointment requests or legal operation of the website.'
              : 'Der Schutz personenbezogener Daten ist uns wichtig. Diese Website erhebt und verarbeitet Daten nur dort, wo dies für Kontaktaufnahme, Terminanfragen oder den rechtssicheren Betrieb der Website erforderlich ist.'}
          </p>
        </Section>

        <Section>
          <h2>{isEnglish ? 'Appointment requests' : 'Terminbuchung'}</h2>
          <p>
            {isEnglish
              ? 'Data entered in the appointment form is currently used to prepare a WhatsApp appointment request. In this static MVP version, no automatic database storage takes place on this website.'
              : 'Die im Terminformular eingegebenen Daten werden derzeit zur Vorbereitung einer WhatsApp-Terminanfrage verwendet. In dieser statischen MVP-Version erfolgt auf dieser Website keine automatische Datenbankspeicherung.'}
          </p>
        </Section>

        <Section>
          <h2>{isEnglish ? 'Image material and AI-generated images' : 'Bildmaterial und KI-generierte Bilder'}</h2>
          <p>
            {isEnglish
              ? 'Some service images on this website are AI-generated illustrative images. They do not show real customers and are not based on customer photos. These images are used only for visual presentation of the offered services and do not involve processing personal data of real persons.'
              : 'Einzelne Leistungsbilder auf dieser Website sind KI-generierte Symbolbilder. Sie zeigen keine echten Kundinnen und beruhen nicht auf Kundinnenfotos. Die Bilder dienen ausschließlich der visuellen Darstellung der angebotenen Leistungen; dabei werden keine personenbezogenen Daten realer Personen verarbeitet.'}
          </p>
        </Section>

        <Section>
          <h2>WhatsApp</h2>
          <p>
            {isEnglish
              ? 'When using the WhatsApp link, WhatsApp is opened. Communication then takes place outside this website via WhatsApp. Please note the privacy policy of WhatsApp.'
              : 'Bei Nutzung des WhatsApp-Links wird WhatsApp geöffnet. Die Kommunikation erfolgt anschließend außerhalb dieser Website über WhatsApp. Bitte beachten Sie die Datenschutzbestimmungen von WhatsApp.'}
          </p>
        </Section>

        <Section>
          <h2>{isEnglish ? 'Contact' : 'Kontaktaufnahme'}</h2>
          <p>
            {isEnglish
              ? 'If you contact us by phone, email or WhatsApp, the information provided will be used to process your request.'
              : 'Wenn Sie telefonisch, per E-Mail oder per WhatsApp Kontakt aufnehmen, werden die angegebenen Informationen zur Bearbeitung der Anfrage verwendet.'}
          </p>
        </Section>

        <Section>
          <h2>{isEnglish ? 'External services' : 'Externe Dienste'}</h2>
          <p>
            {isEnglish
              ? 'If services such as Google Maps, analytics tools or online booking integrations are added later, this privacy policy will be updated before go-live.'
              : 'Sollten später Dienste wie Google Maps, Analyse-Tools oder Online-Terminbuchungsintegrationen ergänzt werden, wird diese Datenschutzerklärung vor dem Livegang entsprechend angepasst.'}
          </p>
        </Section>

        <Section>
          <h2>{isEnglish ? 'Responsible party' : 'Verantwortliche Stelle'}</h2>
          <p>
            {siteConfig.legal.owner}<br />
            {siteConfig.address.street}<br />
            {siteConfig.address.zip} {siteConfig.address.city}<br />
            {siteConfig.address.country}<br />
            <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
          </p>
        </Section>
      </Card>
    </Page>
  );
}

export default Datenschutz;
